import { ReactNode } from "react";
import { AnnotationButton } from "../../components/annotations/AnnotationButton";
import { useTableContext } from "./TableContextProvider";
import { AitTablePosition } from "./functions/interface";

interface AitColumnAnnotationButtonProps {
  originalColumnIndex: number;
  columnId: string;
}

/**
 * Button for adding or editing an annotation on a table column.
 *
 * @param props - Component props
 * @param props.originalColumnIndex - The original source index of the column before any reordering
 * @param props.columnId - The unique identifier for the column
 */
export const AitColumnAnnotationButton = ({
  originalColumnIndex,
  columnId,
}: AitColumnAnnotationButtonProps): ReactNode => {
  const { state } = useTableContext();
  if (!state || originalColumnIndex < 0 || !columnId) return null;

  // Get the annotation from the columnInformation list using columnId
  const columnAnnotation = state.originalTableData.columnInformation.find(
    (ci) => ci.columnId === columnId,
  )?.annotation;

  return (
    <AnnotationButton
      buttonId={`column-${columnId}-annotation`}
      annotationType="Column"
      annotationLocation={{
        position: AitTablePosition.column,
        originalColumn: originalColumnIndex,
        columnId,
      }}
      existingAnnotation={columnAnnotation}
      hidden={state.tlfViewMode.value !== "ANNOTATIONS"}
      showPreview={false}
    />
  );
};

AitColumnAnnotationButton.displayName = "AitColumnAnnotationButton";
